export const AppGlobals = { 
    
baseAppUrl:'https://portalapi.oicgulf.ae/api/'

}




